import {
  IconButton,
  Scrollbar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';

import { FC } from 'react';
import { ProjectItem } from '../../components';
import { sendManagerEvent } from '../../xstate/app.xstate';
import { ManagerContext } from '../../xstate/manager.xstate.types';
import { useProjectsWithReleasedTools } from '../../hooks';

interface ProjectTableProps {
  projects: ManagerContext['projectsNew'];
}

export const ProjectsTable: FC<ProjectTableProps> = ({
  projects: allProjects,
}) => {
  const projects = useProjectsWithReleasedTools(allProjects);
  return (
    <Scrollbar forceVisible disableAutoHide>
      <Table test-id="home-page-projects-table" size="small">
        <TableHead>
          <TableRow>
            <TableCell variant="th">
              <TranslationComponent i18nKey="manager/common:homepage.projects.project">
                Project
              </TranslationComponent>
              <IconButton size="xsmall" name="chevron-down" slot="sorter" />
            </TableCell>
            <TableCell variant="th" sortActive>
              <TranslationComponent i18nKey="manager/common:homepage.projects.tools">
                Tools
              </TranslationComponent>
              <IconButton size="xsmall" name="chevron-down" slot="sorter" />
            </TableCell>
            <TableCell variant="th" align="end">
              <TranslationComponent i18nKey="manager/common:homepage.projects.lastUpdated">
                Last updated
              </TranslationComponent>
              <IconButton size="xsmall" name="chevron-down" slot="sorter" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projects?.map((item) => (
            <ProjectItem
              key={item.id}
              item={item}
              onClick={() =>
                sendManagerEvent({
                  type: 'manager.selectProjectModal',
                  id: item.id,
                })
              }
            />
          ))}
        </TableBody>
      </Table>
    </Scrollbar>
  );
};
